// import React from "react"

//prop type
import PropTypes from "prop-types"

// Mui
import { FormHelperText } from "@mui/material"

// =======================================|| HELPER TEXT - COMPONENTS ||=====================================================
const ValidationHelperText = ({ touched = false, error = false, helperText = "", ...others }) => {
  return (
    <FormHelperText
      style={{ marginTop: "0px", marginBottom: "0px" }}
      {...others}
      error
      sx={{ my: 0, fontSize: "10px" }}
    >
      {error ? helperText : ""}
    </FormHelperText>
  )
}

ValidationHelperText.prototype = {
  error: PropTypes.bool,
  touched: PropTypes.bool,
  helperText: PropTypes.string.isRequired,
  other: PropTypes.any
}

export default ValidationHelperText
